import React from "react";
import { Button, Col } from "react-bootstrap";
import { TooltipCustom } from "@services/ui-components";
import SaleTooltipContent from "../../../Warehouse/WarehousesOperations/SaleProducts/SaleTooltipContent/SaleTooltipContent";

interface SaleOfProductsButtonProps {
    bookingUuid?: string;
    isInfoForSalesTooltip: boolean;
    infoForSalesTooltip?: {
        saleActionDate?: string;
        saleActionProductsAmount?: number;
    };
    isBookingSale: boolean;
    onClick: () => void;
    translate: (key: string) => string;
    tooltipResetKey?: number;
}

const SaleOfProductsButton: React.FC<SaleOfProductsButtonProps> = ({
    bookingUuid,
    isInfoForSalesTooltip,
    infoForSalesTooltip,
    isBookingSale,
    onClick,
    translate,
    tooltipResetKey,
}) => {
    if (!bookingUuid) return null;

    const button = (
        <Button variant="outline-orange w-100" onClick={onClick}>
            <span className="position-relative d-inline-block me-2">
                <i className="bi bi-cart4 fs-normal"></i>
                {isBookingSale && (
                    <span
                        className="position-absolute bg-green translate-middle rounded-circle"
                        style={{ width: "5px", height: "5px", top: "8px", right: "-3px" }}
                    />
                )}
            </span>
            {translate("Sale of products")}
        </Button>
    );

    return (
        <Col md={6} xl={5} className="mt-3 mt-lg-0">
            {isInfoForSalesTooltip ? (
                <TooltipCustom
                    overlayTooltipKey={tooltipResetKey}
                    placement="bottom"
                    text={
                        <SaleTooltipContent
                            actionDate={infoForSalesTooltip?.saleActionDate}
                            saleActionProductsAmount={infoForSalesTooltip?.saleActionProductsAmount}
                        />
                    }
                >
                    {button}
                </TooltipCustom>
            ) : (
                button
            )}
        </Col>
    );
};

export default SaleOfProductsButton;
